// extracted by mini-css-extract-plugin
export var container = "_q2-0";
export var dotAnimation = "_q2-2";
export var dotsLoading = "_q2-1";